import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ServiceRequestFLTR } from '../models/service-request/service-request.filter.model';
import { JsonResult } from '../core/json-result.model';
import { ServiceRequestTBL } from '../models/service-request/service-request.table.model';
import { Observable } from 'rxjs';
import { ServiceRequestDetailTBL } from '../models/service-request/service-request-detail.table.model';
import { GasNetworkZoneFLTR } from '../models/localization/gas-network-zone.filter.model';
import { GasNetworkZoneRSPNS } from '../models/localization/gas-network-zone.response.model';
import { ServiceRequestInsert } from '../models/service-request/service-request-insert.model';
import { ServiceRequestInsertResponse } from '../models/service-request/service-request-insert-response.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil } from 'rxjs/operators';
import { ServiceRequestKioskoOpe } from '../models/service-request/service-request-kiosko-ope';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {
  controller = 'ServiceRequest';
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }

  list(filter: ServiceRequestFLTR): Observable<JsonResult<ServiceRequestTBL[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/List`;
    return this.httpClient.post<any>(url, filter).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  listKiosko(clientCode, referenceNumber, operationType): Observable<JsonResult<ServiceRequestKioskoOpe>>{
    let params = new HttpParams();
    params = params.set('clientCode', clientCode);
    params = params.set('referenceNumber', referenceNumber);
    params = params.set('operationType', operationType);
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/ListKiosko`;
    return this.httpClient.get<any>(url,{ params }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  listDetail(requestId: string): Observable<JsonResult<ServiceRequestDetailTBL[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/${requestId}/ListDetails`;
    return this.httpClient.get<any>(url);
  }
  searchGasNetworkZone(filter: GasNetworkZoneFLTR): Observable<JsonResult<GasNetworkZoneRSPNS>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Localization/SearchGasNetworkZone`;
    return this.httpClient.post<any>(url, filter);
  }
  add(serviceRequest: ServiceRequestInsert) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/Add`;
    return this.httpClient.post<JsonResult<ServiceRequestInsertResponse>>(url, serviceRequest);
  }
}
